import { useMemo } from 'react';
import { useDashboardPermissions } from '@components';
import { useGetCampaignQuery } from '../../../hooks/useGetCampaignQuery';
import { getBonus } from '../modules/CampaignRecommendation/utils';
const INCENTIVE_TO_RECOMMENDATION_MAP = {
    ORDER_SAMPLES: 'orderSamples',
    CREATE_PROMOTION: 'promotions',
    CREATE_N_OR_MORE_PRODUCTS: 'createProduct',
    VERIFY_DISCORD: 'joinDiscord',
    INSTALL_MOBILE_APP: 'creatorApp',
    INSTALL_N_OR_MORE_APPS: 'integrations',
    MAKE_FIRST_SALES: undefined,
    DOUBLE_SIGNUP_REFERRAL_BONUS: 'referral',
};
export const useCampaignStatus = () => {
    const { hasPermission } = useDashboardPermissions();
    const { campaignQuery } = useGetCampaignQuery(undefined, {
        enabled: hasPermission('home.campaign'),
    });
    const campaignIncentives = useMemo(() => {
        if (!campaignQuery.data)
            return [];
        const incentives = [];
        campaignQuery.data.campaignIncentives.forEach((incentive) => {
            const recommendationId = INCENTIVE_TO_RECOMMENDATION_MAP[incentive.type];
            const bonus = getBonus(incentive.bonus);
            if (recommendationId && !incentive.isCompleted && bonus) {
                incentives.push({
                    recommendationId,
                    incentive: {
                        ...incentive,
                        bonus,
                    },
                });
            }
        });
        return incentives;
    }, [campaignQuery.data]);
    return {
        isLoading: campaignQuery.isLoading,
        activeIncentives: campaignIncentives,
    };
};
